import { render, staticRenderFns } from "./jpointSetting.vue?vue&type=template&id=1ad672de&scoped=true"
import script from "./jpointSetting.vue?vue&type=script&lang=js"
export * from "./jpointSetting.vue?vue&type=script&lang=js"
import style0 from "./jpointSetting.vue?vue&type=style&index=0&id=1ad672de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad672de",
  null
  
)

export default component.exports